import axios from 'axios';

const globalVar = phpData;
const ajaxUrl = globalVar.ajaxUrl;

function listarBannerGDN(callback) {

  const form = new FormData();
  form.append('action', 'listar_bannerGDN');

  axios
    .post(ajaxUrl, form)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callback(error);
    });
}

module.exports = listarBannerGDN;



// WEBPACK FOOTER //
// ./src/assets/js/listarBannerGDN.js